import { Collapse, Input } from '@appd/uik';
import { memo, useEffect, useState } from 'react';
import { ToggleSwitchWithTitle } from '.';
import { WidgetPropertiesPanelProps } from '../../models';
import { getStyles } from '../../visualizationTypes/getStyles';

const { PANEL, PROPERTY } = getStyles();

export const CardOptionsSection = memo(({ props, updateProps }: WidgetPropertiesPanelProps): JSX.Element => {
  const [isTitleEnabled, setIsTitleEnabled] = useState<boolean>(props?.title != null);
  const [title, setTitle] = useState<string>(props?.title ?? '');
  const [titleInput, setTitleInput] = useState<string>(title);
  // Subtitle is not supported yet
  // const [isSubtitleEnabled, setIsSubtitleEnabled] = useState<boolean>(props?.subtitle != null);
  // const [subtitle, setSubtitle] = useState<string>(props?.subtitle ?? '');
  // const [subtitleInput, setSubtitleInput] = useState<string>(subtitle);

  useEffect(() => {
    setIsTitleEnabled(props?.title != null);
    setTitle(props?.title ?? '');
    if (props?.title != null) {
      setTitleInput(props?.title ?? '');
    }

    // Subtitle is not supported yet
    // setIsSubtitleEnabled(props?.subtitle != null);
    // setSubtitle(props?.subtitle ?? '');
  }, [props]);

  return (
    <Collapse.Group data-testid="dashify-widget-properties-panel-card-options" open={[true]}>
      <Collapse title="Card">
        <Collapse.Panel className={PANEL}>
          <div key="title" className={PROPERTY as string}>
            <ToggleSwitchWithTitle
              title="Title"
              key="isTitleEnabled"
              on={isTitleEnabled}
              onSwitch={on => {
                setIsTitleEnabled(on);
                updateProps({
                  title: on ? titleInput ?? '' : null,
                });
              }}
            />
            {isTitleEnabled && (
              <Input
                key="titleInput"
                name="titleInput"
                value={titleInput}
                onChange={e => {
                  setTitle(e.target.value);
                  setTitleInput(e.target.value);
                  updateProps({
                    title: e.target.value,
                  });
                }}
                required={true}
              />
            )}
          </div>
          {/* Subtitle is not supported yet*/}
          {/* <div key="subtitle" className={PROPERTY as string}>
            <ToggleSwitchWithTitle
              title="Subtitle"
              key="isSubtitleEnabled"
              on={isSubtitleEnabled}
              onSwitch={on => {
                setIsSubtitleEnabled(on);
                updateProps({
                  subtitle: on ? subtitleInput ?? '' : null,
                });
              }}
            />
            {isSubtitleEnabled && (
              <Input
                key="subtitleInput"
                name="subtitleInput"
                value={subtitle}
                onChange={e => {
                  setSubtitle(e.target.value);
                  setSubtitleInput(e.target.value);
                  updateProps({
                    subtitle: e.target.value,
                  });
                }}
                required={true}
              />
            )}
          </div> */}
        </Collapse.Panel>
      </Collapse>
    </Collapse.Group>
  );
});
